import { render, staticRenderFns } from "./TheContact.vue?vue&type=template&id=25d212b9&"
import script from "./TheContact.vue?vue&type=script&lang=js&"
export * from "./TheContact.vue?vue&type=script&lang=js&"
import style0 from "./TheContact.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports